import '../styles/globals.css';
import type { AppProps } from 'next/app';
import { ThemeProvider } from 'styled-components';
import { useState, createContext } from 'react';

const colours = {
  lightBrown: '#ddd2b6',
  darkBackground: '#fedfbb',
  lightBackground: '#faf1e7',
  hover: '#fafaf1',
  titleBackground: '#fafafa',
};

const theme = {
  colours,
};

interface DarkModeContext {
  darkMode: string;
  setDarkMode: any;
};

export const DarkModeContext = createContext({} as DarkModeContext)

export default function App({ Component, pageProps }: AppProps) {
  const [darkMode, setDarkMode] = useState('light');
  return (
    <DarkModeContext.Provider
      value={{
        darkMode,
        setDarkMode,
      }}
    >
      <ThemeProvider theme={theme}>
        <Component {...pageProps} />
      </ThemeProvider>
    </DarkModeContext.Provider>
  );
}
